import { getCloseButtonStyles } from "../utils/closeButtonStyles";
import React, { useEffect, useState } from "react";
import { AiOutlineEye } from "react-icons/ai";
import { GoDeviceDesktop } from "react-icons/go";
import { CiMobile3 } from "react-icons/ci";
import { Button } from "../../../components";
import useExpiryCountDown from "../../../components/customHook/CustomNudge/useExpiryCountDown";
import { useSelector } from "react-redux";
// import { SelectUserWebsiteURL } from "../../DesignEditor/designEditorSlice";
import { handleToast } from "../../../helper";
import { SelectUserWebsiteURL } from "../../../common/authenticateDashboard/authSlice";

const PreviewNudge = ({
  nudgeMode,
  setNudgeMode,
  customizeState,
  nudgePosition,
  userPersonaKey
}) => {
  const [isPreview, setIsPreview] = useState(false);
  const userWebsiteURL = useSelector(SelectUserWebsiteURL)
  console.log("userWebsiteURL", userWebsiteURL)

  const handleDesktopMode = () => {
    setNudgeMode("desktop");
  };

  const handleMobileMode = () => {
    setNudgeMode("mobile");
  };

  const handlePreviewClose = () => {
    setIsPreview(false);
  };

  const hanldePreview = () => {
        // setIsPreview(true);

    if (userWebsiteURL === "") {
      handleToast("warning", "Add website URL to view the preview.");
      return;
    }
  
    // Encode userPersonaKey using Base64
    const encodedPersonaKey = btoa(userPersonaKey); 
  
    const previewURL = `${userWebsiteURL}?cf_debug=true&nudge_id=${encodedPersonaKey}`;

    // Copy the URL to the clipboard
    navigator.clipboard
    .writeText(previewURL)
    .then(() => {
      handleToast("success", "Preview URL copied to clipboard!");
    })
    .catch((err) => {
      console.error("Failed to copy URL to clipboard: ", err);
      handleToast("error", "Failed to copy URL to clipboard.");
    });
    
    window.open(previewURL, '_blank');
  };

  return (
    <div className="previewNudge p-4 flex gap-2 flex-col sm:flex-row items-center justify-between overflow-hidden">
      <div className="custmization__modes flex gap-2 items-center flex-col sm:flex-row">
        <span className="previewText">MODE:</span>
        <Button
          onClick={handleDesktopMode}
          title="DESKTOP"
          Icon={GoDeviceDesktop}
          active={nudgeMode === "desktop"}
        />
        <Button
          onClick={handleMobileMode}
          title="MOBILE"
          Icon={CiMobile3}
          active={nudgeMode !== "desktop"}
        />
      </div>
      <Button
        onClick={hanldePreview}
        title="PREVIEW"
        Icon={AiOutlineEye}
        active={false}
      />
      {isPreview && nudgeMode === "desktop" && (
        <PreviewModal nudgeMode={nudgeMode}>
          <Nudge
            customizeState={customizeState}
            nudgePosition={nudgePosition}
            previewMode="desktop"
          />
          <button
            type="button"
            onClick={handlePreviewClose}
            className="close__preview absolute top-8 right-12 bg-gray-500 rounded-full px-3 py-2"
          >
            X
          </button>
        </PreviewModal>
      )}
      {isPreview && nudgeMode !== "desktop" && (
        <PreviewModal nudgeMode={nudgeMode}>
          <Nudge
            customizeState={customizeState}
            nudgePosition={nudgePosition}
            previewMode="mobile"
          />
          <button
            type="button"
            onClick={handlePreviewClose}
            className="close__preview absolute top-0 -right-12 bg-gray-500 rounded-full px-3 py-2"
          >
            X
          </button>
        </PreviewModal>
      )}
    </div>
  );
};

const PreviewModal = ({ nudgeMode, children }) => {
  return (
    <div className="fixed z-30 inset-0 overflow-hidden">
      <div className="flex items-center justify-center min-h-screen text-center sm:block ">
        <div className="fixed inset-0 transition-opacity" aria-hidden="true">
          <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>
        <div
          className={`preview ${
            nudgeMode === "desktop"
              ? "w-[99dvw] h-screen"
              : "w-[390px] h-screen mx-auto"
          } relative bg-gray-600 `}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

const Nudge = ({ customizeState, nudgePosition, previewMode }) => {
  const [userNudge_OfferTextFinal, setUserNudge_OfferTextFinal] = useState("");

  const minutes = +customizeState?.nudgeOfferText?.minutes;

  const isExpiryTimer = customizeState?.nudgeOfferText?.isExpiryTimer;

  // reusable custom hook returns a timer state (string - HH:MM:SS)
  const timer = useExpiryCountDown(minutes, isExpiryTimer);

  let left = 0;
  let top = 0;

  if (previewMode === "desktop") {
    left = nudgePosition.desktop?.left;
    top = nudgePosition.desktop?.top;
  } else {
    top = nudgePosition.mobile?.top;
  }

  useEffect(() => {
    let userNudge_offerText = customizeState?.nudgeOfferText?.text;
    let userNudge_ExpiryTime = customizeState?.nudgeOfferText?.minutes;
    let modified_userNudge_offerText = userNudge_offerText?.replace(
      "{time}",
      timer
    );
    console.log(modified_userNudge_offerText, "1");
    modified_userNudge_offerText = modified_userNudge_offerText?.replace(
      "minutes",
      ""
    );
    console.log(modified_userNudge_offerText, "2");

    modified_userNudge_offerText = modified_userNudge_offerText?.replace(
      "hours",
      ""
    );
    console.log(modified_userNudge_offerText, "3");
    setUserNudge_OfferTextFinal(modified_userNudge_offerText);
    console.log(timer);
  }, [customizeState?.nudgeOfferText, timer]);
  // useEffect(()=>{
  //     setUserNudge_OfferTextFinal(
  //       userNudge_OfferTextFinal?.replace("{time}", timer)
  //     );
  // },[timer])
  useEffect(() => {
    const target = document.getElementById("nudge-preview");
    if (!target) throw new Error("Element with given id doesn't exist");

    const container = target.parentElement;
    if (!container) throw new Error("target element must have a parent");

    target.style.position = "absolute"; // Make sure the element is absolutely positioned

    const parentRect = container.getBoundingClientRect(); // Get parent's bounding rectangle

    const initialXPercent = left > 70 ? 100 : left;
    let initialYPercent = null;
    if (previewMode === "desktop") {
      initialYPercent = top > 70 ? 100 : top;
    } else {
      initialYPercent = top;
    }

    // if (left > 70) {
    //     handleToast('error', `Nudge is out of screen, left ${left}`);
    // } else if (top > 70) {
    //     handleToast('error', `Nudge is out of screen, top ${top}`);
    // }

    // Calculate initial position based on percentages
    const initialX = Math.round((parentRect.width * initialXPercent) / 100);
    const initialY = Math.round((parentRect.height * initialYPercent) / 100);

    // Ensure the initial positions do not exceed parent's boundaries
    const maxX = parentRect.width - target.offsetWidth;
    const maxY = parentRect.height - target.offsetHeight;

    const boundedInitialX = Math.min(Math.max(initialX, 0), maxX);
    const boundedInitialY = Math.min(Math.max(initialY, 0), maxY);

    // Set the initial position
    if (previewMode === "desktop") {
      target.style.left = `${boundedInitialX}px`;
      target.style.top = `${boundedInitialY}px`;
    } else {
      target.style.top = `${boundedInitialY}px`;
      target.style.left = "50%";
      target.style.transform = "translateX(-50%)";
    }
  }, [left, top, previewMode]);

  if (customizeState?.useHtmlDesign) {
    return (
      <div
        id="nudge-preview"
        className="nudge rounded shadow-md select-none"
        style={{
          position: "absolute",
          maxWidth: "100%",
        }}
        dangerouslySetInnerHTML={{ __html: customizeState.htmlDesignCode || '<div style="padding: 20px; color: #888;">Enter HTML code design to preview</div>' }}
      />
    );
  }

  return (
    <div
      id="nudge-preview"
      className="nudge rounded shadow-md p-3 flex justify-center flex-col gap-3 text-center select-none"
      style={{
        backgroundColor: `${customizeState?.nudge?.backgroundColor}`,
        borderWidth: `${customizeState?.nudge?.borderWidth}px`,
        borderColor: `${customizeState?.nudge?.nudgeBorderColor}`,
        borderStyle: `${customizeState?.nudge?.borderStyle}`,
        position: "absolute",
        width:"20%"
      }}
    >
      <span
          className="crossicon absolute font-bold cursor-pointer text-xs"
          style={getCloseButtonStyles(customizeState)}
        >
        X
      </span>
      <p
        className="text-sm text-gray-800 break-words"
        style={{
          fontStyle: `${customizeState?.nudgeOfferText?.fontStyle}`,
          color: `${customizeState?.nudgeOfferText?.textColor}`,
          backgroundColor: `${customizeState?.nudgeOfferText?.backgroundColor}`,
          borderColor: `${customizeState?.nudgeOfferText?.borderColor}`,
          borderStyle: `${customizeState?.nudgeOfferText?.borderStyle}`,
          overflow: "visible",
        }}
      >
        <span className="nudgeText">{userNudge_OfferTextFinal}</span>
        {/* <span className="nudgeTimer font-semibold mx-1">{timer}</span> */}
      </p>
      <p
        className="text-sm font-semibold px-4 py-1 rounded break-words"
        style={{
          fontStyle: `${customizeState?.nudgeCouponCode?.fontStyle}`,
          color: `${customizeState?.nudgeCouponCode?.textColor}`,
          backgroundColor: `${customizeState?.nudgeCouponCode?.backgroundColor}`,
          borderWidth: `${customizeState?.nudgeCouponCode?.borderWidth}px`,
          borderColor: `${customizeState?.nudgeCouponCode?.borderColor}`,
          borderStyle: `${customizeState?.nudgeCouponCode?.borderStyle}`,
        }}
      >
        {customizeState?.nudgeCouponCode?.text}
      </p>
      <p
        className="text-sm rounded px-4 py-1 text-gray-300 break-words"
        style={{
          fontStyle: `${customizeState?.nudgeCopyCode?.fontStyle}`,
          color: `${customizeState?.nudgeCopyCode?.textColor}`,
          backgroundColor: `${customizeState?.nudgeCopyCode?.backgroundColor}`,
          borderWidth: `${customizeState?.nudgeCopyCode?.borderWidth}px`,
          borderColor: `${customizeState?.nudgeCopyCode?.borderColor}`,
          borderStyle: `${customizeState?.nudgeCopyCode?.borderStyle}`,
        }}
      >
        {customizeState?.nudgeCopyCode?.text}
      </p>

      {/* Tutorial video CTA (href + styling) */}
      <p 
        className="text-sm mt-[-14px]" 
        style={{
          display: customizeState?.nudgeTutorialVideo?.display ?? "none",
          fontStyle: `${customizeState?.nudgeTutorialVideo?.fontStyle}`,
          color: `${customizeState?.nudgeTutorialVideo?.textColor}`,
          fontSize: `${11}px`,
        }}
      >
        {customizeState?.nudgeTutorialVideo?.text}
        <a 
          className="text-blue-500 underline cursor-pointer" 
          href={customizeState?.nudgeTutorialVideo?.href} 
          target="_blank" rel="noreferrer"
          style={{
            color: `${customizeState?.nudgeTutorialVideo?.linkTextColor}`,
          }}
        >
          {customizeState?.nudgeTutorialVideo?.linkText}
        </a>
        </p>
      {/* <span className="crossicon absolute top-1 text-gray-800 font-bold right-2 cursor-pointer text-xs">X</span> */}
    </div>
  );
};

export default PreviewNudge;
